import { createFileRoute } from "@tanstack/react-router";
import { useQuery } from "convex/react";
import { useTranslation } from "react-i18next";

import { api } from "../../convex/_generated/api";
import { PaneHeader } from "@/components/settings/frame";
import { SupportForm } from "@/components/shell/support-form";

export const Route = createFileRoute("/settings/help")({
  component: HelpPage,
});

function HelpPage() {
  const { t } = useTranslation("settings");
  const me = useQuery(api.auth.getCurrentUser);
  return (
    <div>
      <PaneHeader title={t("nav.help")} description={t("help.description")} />
      <div className="border-t border-line-strong pt-6">
        <SupportForm email={me?.email} />
      </div>
    </div>
  );
}
